import { render, staticRenderFns } from "./TecnicoList.vue?vue&type=template&id=4d443a97"
import script from "./TecnicoList.vue?vue&type=script&lang=js"
export * from "./TecnicoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports